import MuiContainer from '@ahamove/web-components/lib/Container';
import { useTranslation } from 'next-i18next';
import { useEffect, useMemo } from 'react';
import { useGetListContracts } from '@/api/contract/useGetListContracts';
import {
  PREVIOUS_BOOKINGS_STATUS,
  UPCOMING_BOOKINGS_STATUS,
} from '@/lib/constants';
import Container from '@/shared-components/layouts/Container';
import useIsMobile from '@/shared-hooks/useIsMobile';
import { useAuth } from '../auth/AuthProvider';
import EmptyRecord from './EmptyRecord';
import ListRecord from './ListRecord';
import { recordConfig } from './recordConfig';

export default function RecordPage() {
  const { t } = useTranslation(recordConfig.i18nNamespaces);
  const isMobile = useIsMobile();
  const { accessToken, isLoadingUser, user } = useAuth();
  const {
    data: contracts,
    isLoading: isLoadingGetListContracts,
    refetch,
  } = useGetListContracts({
    cacheTime: 0,
  });
  const upcomingBookingsList = useMemo(() => {
    if (contracts && contracts.length)
      return contracts.filter((contract) =>
        Object.keys(UPCOMING_BOOKINGS_STATUS).includes(contract.status)
      );
  }, [contracts]);

  const previousBookingsList = useMemo(() => {
    if (contracts && contracts.length)
      return contracts.filter((contract) =>
        Object.keys(PREVIOUS_BOOKINGS_STATUS).includes(contract.status)
      );
  }, [contracts]);

  useEffect(() => {
    refetch();
  }, [accessToken]);

  return (
    <Container title={String(t('common:page.my_bookings'))}>
      <MuiContainer
        data-test-id="recordPageContainer"
        maxWidth="xl"
        sx={{
          pt: isMobile ? 0 : 2,
          pb: isMobile ? 4 : 11,
          px: isMobile ? 0 : 3,
          display: 'flex',
          flexDirection: 'column',
          flexGrow: 1,
        }}
      >
        {user ? (
          <>
            <ListRecord
              title="upcoming_bookings"
              data={upcomingBookingsList}
              loading={isLoadingGetListContracts}
            />
            <ListRecord
              title="previous_bookings"
              data={previousBookingsList}
              loading={isLoadingGetListContracts}
            />
          </>
        ) : (
          <EmptyRecord
            loading={isLoadingUser}
            title={t('record:list.empty_no_login') || ''}
          />
        )}
      </MuiContainer>
    </Container>
  );
}
